// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import camelize from 'camelize2';
import { zooplaPublicAPIFetch } from '@zoopla/data/core';

export async function navigation(
    path: string
): Promise<[unknown | null, Error | null]> {
    try {
        const url = new URL(process.env.NAVIGATION_API);
        url.searchParams.append('uri', path);

        const j = await zooplaPublicAPIFetch({
            host: url.host,
            path: `${url.pathname}${url.search}`,
            secret: process.env.NAVIGATION_SECRET
        });
        const response = {};
        response.breadcrumbs = camelize(j.breadcrumbs);
        response.redirects = camelize(j.http_status ? [j.http_status] : []);
        response.seoAccordions = camelize(
            j.accordions?.sidebar_seo_accordion || []
        );

        const housePricesKey = 'housePrices';
        const findAgentsKey = 'findAgents';
        const i18nKey = 'i18n_label_key';

        const housePriceItem = j.top_navigation_tree?.find(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (item) => item[i18nKey] === housePricesKey
        );
        const findAgentsItem = j.top_navigation_tree?.find(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (item) => item[i18nKey] === findAgentsKey
        );

        response.discoverMore = {
            housePricesUri: housePriceItem?.uri || '',
            findAgentsUri: findAgentsItem?.uri || ''
        };

        return [response, null];
    } catch (e) {
        return [{}, e];
    }
}
